import React from 'react';
import cn from 'classnames';
import { Affix } from 'antd';
import SearchQuestions from '../SearchQuestions/SearchQuestions';
import FilterDropdown from '../FilterDropdown/FilterDropdown';
import styles from './Actions.module.scss';

const Actions = () => {
  return (
    <Affix className={cn('dispex-filter-button', styles.root)} offsetTop={10}>
      <div className={styles.wrapper}>
        <SearchQuestions />
        <FilterDropdown />
      </div>
    </Affix>
  );
};

export default Actions;
